<template>
  <wrap :minHeightValue="300" width="60%" class="d_wrap" ref="wrap" title="修改密码">
    <div class="update_password">

      <div class="input_wrap">
        <label>
          <span class="label">旧密码：</span>
          <input type="password" v-model="old" placeholder="输入旧密码">
        </label>
        <label>
          <span class="label">新密码：</span>
          <input type="password" v-model="new_pass" placeholder="输入新密码">
        </label>
        <label>
          <span class="label">确认新密码：</span>
          <input type="password" v-model="re_new" placeholder="输入确认新密码">
        </label>
      </div>

      <div class="submit">
        <event tag="button" @click="submit" class="normal-btn t_btn-d active">确认</event>
        <event tag="button" @click="reset" class="normal-btn t_btn-d">重置</event>
      </div>
    </div>
  </wrap>
</template>

<script>
  // qc15复用qc14
  import {password} from '../../service/user';
  import Wrap from "./wrap";
  import mixin from './mixin';

  export default {
    name: "QC24",
    mixins: [mixin],
    components: {Wrap},
    data() {
      return {
        old: '',
        new_pass: '',
        re_new: ''
      };
    },
    methods: {
      reset() {
        this.old = this.new_pass = this.re_new = '';
      },
      rule(type) {
        return (pass, repass) => {
          if (!pass) return type + '不能为空';
          if (!/\w{6,20}/.test(pass)) return type + '输入有误';
          if (repass && pass !== repass) return '新密码两次输入不一致';
        }
      },
      async submit() {
        if (this.loading) return;

        const p1 = this.rule('旧密码');
        const p2 = this.rule('新密码');
        const p3 = this.rule('确认密码');

        const err = p1(this.old) || p2(this.new_pass) || p3(this.re_new) || p3(this.new_pass, this.re_new);
        if (err) return this.$Message.error(err);

        this.loading = true;
        const info = await password({
          old_password: this.old,
          password: this.new_pass,
          password_confirm: this.re_new
        });
        this.loading = false;
        if (info.result === 'ok') {
          this.hide();
          return this.$Message.success('修改成功');
        }
        this.$Message.error(info.msg);

      }
    }
  }
</script>

<style lang="stylus" scoped>
  .d_wrap {
    font-size 14px

    .update_password {
      top 50%
      left 50%
      position absolute
      padding-bottom 30px
      transform translate(-50%, -50%)

      .input_wrap {
        overflow hidden
        padding-right 54px

        > label {
          display block
          margin-top 20px

          > .label {
            display inline-block
            width 100px
            text-align right
          }

          > input {
            width 200px
            height 38px
            outline none
            border 1px solid #ddd
            padding 0 10px
          }
        }
      }
    }

    .submit {
      text-align center
      margin-top 30px

      > button {
        width 80px
        height 35px
        margin 0 5px
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/QC24.vue